
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 .5a1 1 0 00-1 1v6H1a1 1 0 000 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2H9v-6a1 1 0 00-1-1z","fill":"currentColor"}})])
          )
        }
      }
    